import parsePhoneNumber from 'libphonenumber-js';

export default (phone) => {
  let res = phone.trim();
  res = res[0] === '+' ? res : `+${res}`;
  try {
    const parsedPhone = parsePhoneNumber(res);
    return parsedPhone.formatInternational();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('error in phoneFormat:', e);
    return phone;
  }
};
